import React from 'react';
import { Header } from '../components/Header';
import { Pillars } from '../components/Pillars';
import { SocialFeed } from '../components/SocialFeed';
import { CateringCatalog } from '../components/CateringCatalog';
import { ServiceType } from '../components/Navigation';
import { HalloweekPeekers } from '../components/HalloweekPeekers';
interface HomeProps {
  onScrollToCatalog: () => void;
  onBusinessOrder: () => void;
  onBookTable: () => void;
  onJobs: () => void;
  onOrderClick: (type: ServiceType) => void;
  onHalloweek: () => void;
  businessOrderTrigger: number;
}
export function Home({
  onScrollToCatalog,
  onBusinessOrder,
  onBookTable,
  onJobs,
  onOrderClick,
  onHalloweek,
  businessOrderTrigger
}: HomeProps) {
  return <>
      <div className="relative w-full" data-id="element-1325" data-mp="2dj1j4jrqyz3q">
        <HalloweekPeekers onOpen={onHalloweek} data-id="element-1326" data-mp="3kvtljevwhrxy" />
        <Header onScrollToCatalog={onScrollToCatalog} onBusinessOrder={onBusinessOrder} onBookTable={onBookTable} onJobs={onJobs} data-id="element-1327" data-mp="3kv0nd2b0carf" />
      </div>

      <Pillars data-id="element-1328" data-mp="30w9l2xnbqex2" />

      <div className="w-full max-w-5xl mx-auto space-y-12 md:space-y-24 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-1329" data-mp="30up1g32jsgdz">
        <CateringCatalog onOrderClick={onOrderClick} businessOrderTrigger={businessOrderTrigger} data-id="element-1330" data-mp="2vvlugd30c03d" />
        <div className="w-full h-px bg-[#7C8062]/20 max-w-xs mx-auto" data-id="element-1331" data-mp="2mxa7cl1cnkfo" />
        <SocialFeed data-id="element-1332" data-mp="2mz33v7i90o9y" />
      </div>
    </>;
}